/*------------------------------------------------------------------
Import modules
------------------------------------------------------------------*/

import TweenController from '@meteora-digital/tween';
import InViewController from 'scripts/marmalade/classes/in-view';

/*------------------------------------------------------------------
In View events
------------------------------------------------------------------*/

const InView = new InViewController({
  rootMargin: '0px 0px -20% 0px'
});
const Counters = new InViewController({
  rootMargin: '0px 0px -20% 0px'
});

// When these elements enter the page, add the class 'in-view'
InView.on('enter', element => {
  // If this element already has the class 'in-view', return
  if (element.classList.contains('in-view')) return;
  // Add the class 'in-view'
  setTimeout(() => element.classList.add('in-view'), 500);
});

// When items are added to the Counters
Counters.on('init', element => {
  // Grab the text from the element and store it in a data attribute
  element.setAttribute('data-text', element.innerText);
  // Set the element's innerHTML to 0
  element.innerHTML = 0;
});
Counters.on('enter', element => {
  // If this element already has the class 'in-view', return
  if (element.classList.contains('in-view')) return;

  // We will use this to animate the text
  const Tween = new TweenController();
  // Get the element's end value by parsing the data-value attribute and stripping any non-numeric characters
  // Start by stripping any non-numeric characters
  const value = element.getAttribute('data-value').replace(/[^0-9]/g, '');
  // Parse the value as an integer
  const end = parseInt(value);

  // When the tween has stopped, reset the
  Tween.on('end', () => element.innerHTML = element.getAttribute('data-text'));

  // After a slight delay we will tween the Counter to it's desired value
  setTimeout(() => {
    Tween.tween({
      from: 0,
      to: end || 0
    }, value => element.innerHTML = Math.round(value), 1000);
  }, 500);

  // Add the class 'in-view'
  element.classList.add('in-view');
});

// Watch for all element on the page with the class .js-in-view
InView.watch('.js-in-view');
// Watch for all element on the page with the class .js-count
Counters.watch('.js-count');